import { render, staticRenderFns } from "./AddProject.vue?vue&type=template&id=f4bf480e&scoped=true"
import script from "./AddProject.vue?vue&type=script&lang=js"
export * from "./AddProject.vue?vue&type=script&lang=js"
import style0 from "./AddProject.vue?vue&type=style&index=0&id=f4bf480e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bf480e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4bf480e')) {
      api.createRecord('f4bf480e', component.options)
    } else {
      api.reload('f4bf480e', component.options)
    }
    module.hot.accept("./AddProject.vue?vue&type=template&id=f4bf480e&scoped=true", function () {
      api.rerender('f4bf480e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pm/components/AddProject.vue"
export default component.exports